import { render, staticRenderFns } from "./demensionTable.vue?vue&type=template&id=2262c14e&scoped=true&"
import script from "./demensionTable.vue?vue&type=script&lang=js&"
export * from "./demensionTable.vue?vue&type=script&lang=js&"
import style0 from "./demensionTable.vue?vue&type=style&index=0&id=2262c14e&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262c14e",
  null
  
)

export default component.exports